import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign } from "helpers/helpers"

function SummaryBank({ setActiveModal, filterData }) {
	const { t } = useTranslation()

	const [data, setData] = useState([])

	async function searchWithFilter() {
		var filterUrl = "/report-summary-safe"
		var urlParams = ""

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal
				show={true}
				animation={false}
				centered
				size="md"
				onHide={() => setActiveModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('safe')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '20px' }}>#</th>
									<th style={{ 'width': '60%' }}>{t('note')}</th>
									<th className="text-end" style={{ 'width': '20%' }}>{t('expense')}</th>
									<th className="text-end" style={{ 'width': '20%' }}>{t('income')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td>{index + 1}</td>
										<td>{item.note}</td>
										<td className="text-end text-danger">{formatMoney(item.amount_out)}</td>
										<td className="text-end text-success">{formatMoney(item.amount_in)}</td>
									</tr>
								))}
							</tbody>
							<tfoot>
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td className="text-end text-danger">
										<b>{formatMoney(data.total_amount_out)}</b>
									</td>
									<td className="text-end text-success">
										<b>{formatMoney(data.total_amount_in)}</b>
									</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default SummaryBank